var pug = require("!../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;var pug_indent = [];
pug_html = pug_html + "\u003Ci class=\"fas fa-upload\"\u003E\u003C\u002Fi\u003E";;return pug_html;};
module.exports = template;